/**
 * Default values for Flow resource creation
 * Based on Flow CRD definition (synstream.rtsinv.com/v1)
 */

export const defaultImage = {
  url: 'ghcr.io/rootsinnovation/synstream-console',
  tag: 'v1.2.0'
}

export const defaultEnv = {
  variables: {
    AUTH_BASE_URL: 'synstream-auth.synstream-project',
    AUTH_ENABLED: 'true',
    AUTH_LOGIN_PATH: '/api/v2/synstream/login',
    AUTH_LOGOUT_PATH: '/api/v2/synstream/logout',
    AUTH_PORT: '8080',
    AUTH_TOKEN_PATH: '/api/v2/synstream/token',
    AI_HOST: 'synstream-ai.synstream-project',
  }
}

export const defaultFlowConfig = {
  replicas: 1,
  image: defaultImage,
  imagePullPolicy: 'Always',
  service: {
    type: 'ClusterIP',
    port: 1880,
    targetPort: 1880
  },
  storage: {
    enabled: false,
    size: '10Gi',
    deletionPolicy: 'Retain' as const
  }
}

